module.exports = {
  code: "pl",
  hrefLang: "pl-PL",
}

// module.exports = {
//   code: "en",
//   hrefLang: "en-US",
// }
